import React, { useEffect, useState } from 'react';

import AddedBankAccuntDetails from 'src/containers/BusinessOnboarding/BankDetails/AddedBankAccountDetails';
import BankAccountForm from 'src/containers/BusinessOnboarding/BankDetails/BankAccountForm';
import VerifyBankAccountDetailsForm from 'src/containers/BusinessOnboarding/BankDetails/VerifyBankAccountDetailsForm';

import './style.scss';

type SetupBankAccountProps = {
  accountDetails?: BankDetails;
  setAccountDetails: (res: BankDetails) => void;
  onDeleteClick: () => void;
  onVerifySuccess: () => void;
};

const SetupBankAccount: React.FunctionComponent<SetupBankAccountProps> = ({
  accountDetails,
  onDeleteClick,
  setAccountDetails,
  onVerifySuccess,
}) => {
  const [showBankAccountForm, setShowBankAccountForm] = useState<boolean>(!accountDetails);

  useEffect(() => {
    setShowBankAccountForm(!accountDetails);
  }, [accountDetails]);

  return (
    <div>
      <div className="font-size-14 font-weight-bold mb-4">Enter Bank Account Information</div>
      {showBankAccountForm ? <BankAccountForm onSuccess={setAccountDetails} /> : null}
      {!showBankAccountForm && accountDetails ? (
        <>
          <AddedBankAccuntDetails
            onDelete={onDeleteClick}
            values={{
              accountNumber: `**** **** ${accountDetails.last4}`,
              accountHolderName: accountDetails.accountHolderName,
              routingNumber: accountDetails.routingNumber,
            }}
          />
          <div className="font-size-14 font-weight-bold mt-4">Verify Bank Account Details</div>
          <div className="font-size-13 text-muted mb-4 w-50">
            Within 1-2 days, you should receive 2 small deposits in this account. Please enter the amounts of the
            deposits below and click “Verify”.
          </div>
          <VerifyBankAccountDetailsForm bankDetails={accountDetails} onSuccess={onVerifySuccess} />
        </>
      ) : null}
    </div>
  );
};

export default SetupBankAccount;
